// extracted by css-extract-rspack-plugin
export default {"searchWrapper":"searchWrapper-z4lxHQ","showCloseButton":"showCloseButton-K8wwS9","closeButton":"closeButton-KHjVMc"};